export const TASK_ALERT_BANNERS = {
    lowTasks: {
        dismissalKey: 'lowTasksBannerDismissed',
        banner: 'lowTasks',
    },
    outOfTasks: {
        dismissalKey: 'outOfTasksBannerDismissed',
        banner: 'outOfTasks',
    },
    aboutToEnterMeteredBilling: {
        dismissalKey: 'aboutToEnterMeteredBillingBannerDismissed',
        banner: 'aboutToEnterMeteredBilling',
    },
    enteredMeteredBilling: {
        dismissalKey: 'enteredMeteredBillingBannerDismissed',
        banner: 'enteredMeteredBilling',
    },
};
const accountIsInMeteredBilling = ({ accountConsumedTasks, includedTasksPerMonth, }) => {
    return accountConsumedTasks >= includedTasksPerMonth;
};
const accountHasReachedPercentageOfTaskLimit = ({ percentage, taskBufferOverride, maxTasks, consumedTasks, }) => {
    return consumedTasks / (maxTasks * (taskBufferOverride || 1)) >= percentage;
};
const calculateConsumedBaseTasks = ({ accountConsumedTasks, includedTasksPerMonth, isInMeteredBilling, }) => {
    const hasConsumedTasks = includedTasksPerMonth && accountConsumedTasks > 0;
    if (!hasConsumedTasks)
        return 0;
    return isInMeteredBilling ? includedTasksPerMonth : accountConsumedTasks;
};
const getTaskAlertBannerEligibilityForMeteredBilling = ({ accountConsumedTasks, includedTasksPerMonth, }) => {
    const isInMeteredBilling = accountIsInMeteredBilling({
        accountConsumedTasks,
        includedTasksPerMonth,
    });
    const isAboutToEnterMeteredBilling = accountHasReachedPercentageOfTaskLimit({
        percentage: 0.8,
        maxTasks: includedTasksPerMonth,
        consumedTasks: calculateConsumedBaseTasks({
            accountConsumedTasks,
            includedTasksPerMonth,
            isInMeteredBilling,
        }),
    });
    if (isAboutToEnterMeteredBilling && !isInMeteredBilling) {
        return TASK_ALERT_BANNERS.aboutToEnterMeteredBilling.banner;
    }
    if (isInMeteredBilling) {
        return TASK_ALERT_BANNERS.enteredMeteredBilling.banner;
    }
    return null;
};
const getTaskAlertBannerEligibilityForLegacyBilling = ({ taskBufferOverride, accountConsumedTasks, includedTasksPerMonth, }) => {
    const hasReachedLowTaskThreshold = accountHasReachedPercentageOfTaskLimit({
        percentage: 0.8,
        taskBufferOverride: taskBufferOverride || 1,
        maxTasks: includedTasksPerMonth,
        consumedTasks: accountConsumedTasks,
    });
    const hasReached100PercentTaskLimit = accountHasReachedPercentageOfTaskLimit({
        percentage: 1,
        maxTasks: includedTasksPerMonth,
        consumedTasks: accountConsumedTasks,
        taskBufferOverride: taskBufferOverride || 1,
    });
    if (hasReachedLowTaskThreshold && !hasReached100PercentTaskLimit) {
        return TASK_ALERT_BANNERS.lowTasks.banner;
    }
    if (hasReached100PercentTaskLimit) {
        return TASK_ALERT_BANNERS.outOfTasks.banner;
    }
    return null;
};
export const getTaskAlertBannerEligibility = ({ accountHasMeteredBilling, accountConsumedTasks, includedTasksPerMonth, taskBufferOverride, }) => {
    if (accountHasMeteredBilling) {
        return getTaskAlertBannerEligibilityForMeteredBilling({
            accountConsumedTasks,
            includedTasksPerMonth,
        });
    }
    return getTaskAlertBannerEligibilityForLegacyBilling({
        accountConsumedTasks,
        includedTasksPerMonth,
        taskBufferOverride,
    });
};
//# sourceMappingURL=getTaskAlertBannerEligibility.js.map
// @zapier/universal-layout@11.4.2 (c660b09a7)
